import { collection, onSnapshot, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_ORDER_CAPACITY_TABLE } from "../../../constants/FirebaseConstants";

export function useOrderCapacity() {
  const { data } = useSWRSubscription("orderCapacity", (key, { next }) => {
    const q = query(collection(db, FIRESTORE_ORDER_CAPACITY_TABLE));
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
